// extracted by mini-css-extract-plugin
export default {"defaultKindRadius":"aZGrU","containerKindRadius":"bZGrU","cardKindRadius":"cZGrU","iconKindRadius":"dZGrU","responsive":"eZGrU"};